var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleStoreSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 0.819336C9.1905 0.879336 8.19045 1.41916 7.61045 2.13916C7.08045 2.77916 6.64052 3.73919 6.81052 4.66919C7.74052 4.69919 8.70048 4.13919 9.26048 3.41919C9.78048 2.74919 10.1805 1.79934 10.0305 0.819336H10.0405Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4121 6.18921C12.5921 5.15921 11.442 4.56934 10.352 4.56934C8.92202 4.56934 8.31211 5.25928 7.31211 5.25928C6.31211 5.25928 5.50206 4.57935 4.26206 4.57935C3.02206 4.57935 1.74209 5.31937 0.922091 6.59937C-0.237909 8.38937 -0.0379869 11.7692 1.84201 14.6392C2.51201 15.6692 3.412 16.8193 4.582 16.8293C5.622 16.8393 5.922 16.1592 7.332 16.1492C8.742 16.1492 9.0121 16.8293 10.0521 16.8193C11.2221 16.8193 12.172 15.5293 12.842 14.4993C13.322 13.7593 13.502 13.3893 13.872 12.5593C11.162 11.5293 10.7221 7.66921 13.4121 6.18921Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStoreSmallIcon);
export default __webpack_public_path__ + "static/media/appleStoreSmallIcon.2a6db63c4973a06c804d71156af6a79f.svg";
export { ForwardRef as ReactComponent };